import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import { withRouter } from '../../../util/withRouter';
import { Row, Col } from 'react-bootstrap';

import Header from '../../../components/Header/Header';
import { DigitalAddOn, Subscription, SubscriptionPendingChanges, Invoices, PaymentMethod, BillingInfo, Coupons } from '../components';

import { getInvoices, getCustomerBilling, getSettings } from '../BillingActions';

import { trackPageView, PAGES } from '../../../util/mixpanel';

// Import Style
import '../Billing.scss';

// Import Style

class Billing extends Component {
  constructor(props) {
    super(props);
  }

  redirect(to) {
    global.window && window.location && window.location.replace(to + window.location.search);
  }

  componentDidMount() {   
    if (this.props.user && this.props.user.status === 'trial') {
      return this.redirect('/subscribe');
    }
    this.props.getSettings();
    this.props.getCustomerBilling();
    this.props.getInvoices();

    trackPageView(PAGES.BILLING);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user._id !== this.props.user._id && this.props.user.status === 'trial') {
      return this.redirect('/subscribe');
    }
  }

  render() {
    const {settings} = this.props;
    return [
      <Header key="1" title="" showHome={true} />,
      <div key="2" className="content-wrap">
        <Helmet>
          <title>{pageTitle('Billing')}</title>
        </Helmet>
        <div className="billing_content">
          <div className="billing_status">
            <Subscription data={this.props.customer}></Subscription>
            <SubscriptionPendingChanges data={this.props.customer}></SubscriptionPendingChanges>
          </div>
          <Row>
            <Col sm={4}>
              {settings.digitalCompaignIsOn && <DigitalAddOn data={this.props.customer}></DigitalAddOn>}
              <Invoices invoices={this.props.invoices}></Invoices>
              {settings.couponIsOn && <Coupons data={this.props.customer.subscription}></Coupons> }
            </Col>
            <Col sm={8}>
              <PaymentMethod data={this.props.customer}></PaymentMethod>
              <BillingInfo data={this.props.customer}></BillingInfo>
            </Col>
          </Row>
        </div>
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => {
  return {    
    getSettings: () => dispatch(getSettings()),
    getCustomerBilling: () => dispatch(getCustomerBilling()),
    getInvoices: () => dispatch(getInvoices())
  };
};

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    invoices: state.billing.invoices,
    customer: state.billing.customer,
    settings: state.billing.settings
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Billing));
